import React from 'react';

import { HiddenInput, SwitchContainer } from '@aspid/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IconCollection } from '@components/icons/iconCollection';

import { StateLayer } from '../StateLayer';
import { Thumb } from '../Thumb';
import { Track } from '../Track';

import type { SwitchViewProperties } from './SwitchView.types';

export const SwitchView: React.FC<SwitchViewProperties> = ({
  isChecked,
  isDisabled,
  showIcons,
  stateLayerColor,
  iconColor,
  onMouseEnter,
  onMouseLeave,
  onMouseDown,
  onMouseUp,
  onChange,
  inputProps,
  dataTest,
}) => {
  return (
    <SwitchContainer
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      data-testid={dataTest}
    >
      <Track
        isChecked={isChecked}
        isDisabled={isDisabled}
        data-testid={dataTest ? `${dataTest}_track` : undefined}
      >
        <StateLayer
          isChecked={isChecked}
          sx={{ backgroundColor: stateLayerColor }}
          data-testid={dataTest ? `${dataTest}_state_layer` : undefined}
        />
        <Thumb
          isChecked={isChecked}
          isDisabled={isDisabled}
          data-testid={dataTest ? `${dataTest}_thumb` : undefined}
        >
          {showIcons && !isDisabled && (
            <FontAwesomeIcon
              icon={isChecked ? IconCollection.check : IconCollection.cross}
              style={{
                fontSize: isChecked ? 14 : 10,
                color: iconColor,
              }}
            />
          )}
        </Thumb>
        <HiddenInput
          type='checkbox'
          checked={isChecked}
          disabled={isDisabled}
          onChange={onChange}
          data-testid={dataTest ? `${dataTest}_input` : undefined}
          {...inputProps}
        />
      </Track>
    </SwitchContainer>
  );
};
